import { onPickedObservable } from '../../observable/CommonObservable';
import { PickBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { InputCanvasProps } from '../ZEDCameraInputManager';
import type { PickingInfo } from '@babylonjs/core';

export const CommonPick: PickBase = {
  key: 'Pick',
  name: 'Pick',
  type: 'Pick',
  touchCount: 1,
  option: {
    mouseButton: 'all',
    mouseKeyCode: 'none',
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  onPick(_camera: ZEDCamera, touchData: TouchData, pickingInfo: PickingInfo, _canvasProps: InputCanvasProps) {
    if (touchData.dragVector.length() > 10) {
      return;
    }
    if (onPickedObservable.hasObservers()) {
      onPickedObservable.notifyObservers(pickingInfo);
    }
  },
};
